import styles from './index.module.css'
export default function Campains() {
	return (
		<>
			<article className={styles.section} style={{background: 'none'}}>
				<h1>Rabattkoder og tilbud</h1>
				<p>
					Vi har ingen rabattkoder per nå.<br/>
					Kom tilbake senere.
				</p>
			</article>		
		</>
	)
}